import React, { useEffect } from 'react';
import { Trans } from '@lingui/macro';

import PlanOption from '~/app/shared/components/PlanOption';
import { SMARTPAY_PLAN_OPTIONS, SmartPayCustomerType } from '~/app/pages/accounting/bank/smartpay/types';
import SignupForm from '../../SignupForm';
import { useSignupDialogForm } from '../../../hooks/useSignupDialogForm';
import {
    trackSmartPayOnboardingMixpanel,
    getPlanNameForSnowplowEvent,
    trackSmartPayOnboarding,
    PLAN_SELECT_STEP,
    PLAN_SELECT_STEP_MIXPANEL,
    PLAN_SELECT_STEP_CONTINUE,
    PLAN_SELECT_STEP_SELECTED_OPTION,
    PLAN_SELECT_STEP_SELECTED_PER_USE_MIXPANEL,
    PLAN_SELECT_STEP_CONTINUE_WITH_PER_USE_MIXPANEL,
    PLAN_SELECT_STEP_SELECTED_SUBSCRIPTION_MIXPANEL,
    PLAN_SELECT_STEP_CONTINUE_WITH_SUBSCRIPTION_MIXPANEL,
} from '../../../../../tracking/tracking';
import { useSignupDialogOnboardingContext } from '../../../contexts/SignupDialogOnboardingContextProvider';

const SelectPlan = () => {
    const { formData, updateFormData } = useSignupDialogForm();
    const { NFCustomerData } = useSignupDialogOnboardingContext();

    const customerType = NFCustomerData?.customerType ?? SmartPayCustomerType.NewCustomer;
    const customerTypeString = SmartPayCustomerType[customerType];

    useEffect(() => {
        trackSmartPayOnboardingMixpanel(PLAN_SELECT_STEP_MIXPANEL);

        trackSmartPayOnboarding(PLAN_SELECT_STEP, { CustomerType: customerTypeString });
    }, []);

    const onPlanClicked = (planId: number) => {
        updateFormData({ subscriptionType: planId });

        trackSmartPayOnboardingMixpanel(
            planId === 2 ? PLAN_SELECT_STEP_SELECTED_SUBSCRIPTION_MIXPANEL : PLAN_SELECT_STEP_SELECTED_PER_USE_MIXPANEL
        );

        trackSmartPayOnboarding(PLAN_SELECT_STEP_SELECTED_OPTION, {
            Plan: getPlanNameForSnowplowEvent(planId),
            CustomerType: customerTypeString,
        });
    };

    const onNext = () => {
        trackSmartPayOnboardingMixpanel(
            formData?.subscriptionType === 2
                ? PLAN_SELECT_STEP_CONTINUE_WITH_SUBSCRIPTION_MIXPANEL
                : PLAN_SELECT_STEP_CONTINUE_WITH_PER_USE_MIXPANEL
        );

        trackSmartPayOnboarding(PLAN_SELECT_STEP_CONTINUE, {
            Plan: getPlanNameForSnowplowEvent(formData?.subscriptionType),
            CustomerType: customerTypeString,
        });
    };

    return (
        <SignupForm onNext={onNext}>
            <div className="my-6">
                <Trans>
                    Smart Pay is available in two price models based on your needs. You can easily change the pricing model later.
                </Trans>
            </div>

            <div className="flex justify-around my-6">
                {SMARTPAY_PLAN_OPTIONS.map((planDetails, i) => (
                    <PlanOption
                        key={i}
                        selected={formData?.subscriptionType === planDetails.id}
                        onSelect={() => onPlanClicked(planDetails.id)}>
                        <div className="my-2 text-xl font-semibold">{planDetails.name}</div>
                        <div className="my-2">{planDetails.description}</div>
                        <div className="my-2 text-xl">{planDetails.price}</div>
                        <div className="my-2">{planDetails.features}</div>
                    </PlanOption>
                ))}
            </div>
        </SignupForm>
    );
};

export default SelectPlan;
